import { useBookingRoute } from "@/components/hooks/use-booking-route";
import { ActionNavigation } from "@/components/shared/booking/action-navigation";
import { NativeActionNavigation } from "@/components/shared/booking/native-action-navigation";
import { Typography } from "@/components/shared/typography";
import { View } from "@/components/ui";
import {
  useBookingState,
  defaultServiceDetails,
} from "@/store/booking/useBookingState";
import type { ServiceName } from "@/types/service";
import type { ServiceDetail as IServiceDetail } from "@/types/booking";
import { useMemo } from "react";
import { safeGet } from "@/lib/utils";
import { formatPrice } from "@/lib/helpers/number";
import { getServiceUnit } from "@/lib/booking-lib";
import { useRoute } from "@/components/shared/router";

export const ServiceDetailNavigation = ({
  name,
  isReviewService,
  showPricingSection,
}: {
  name: ServiceName;
  isReviewService?: boolean;
  showPricingSection?: boolean;
}) => {
  const { pull } = useRoute();
  const { forward } = useBookingRoute();
  const {
    data: { serviceDetails, packageDetailsFilter },
    setBookingState,
  } = useBookingState();
  const onForward = () => {
    if (isReviewService) {
      pull();
      return;
    }
    setBookingState({
      selectedPackageIds: [],
      selectedSlot: null,
      reservations: [],
      selectedWorkers: [],
      promo: null,
    });
    if (name === "home-beauty" || name === "lashes") {
      setBookingState({
        chooseServicePackageModal: true,
      });
    } else if (name === "home-massage") {
      setBookingState({
        homeMassagePackageModalOpen: true,
      });
    } else if (name === "pet-grooming") {
      setBookingState({
        petCarePackageModalOpen: "pet-grooming",
      });
    } else if (name === "pet-sitting") {
      setBookingState({
        petCarePackageModalOpen: "pet-sitting",
      });
    } else {
      forward();
    }
  };

  const pageServiceDetails = useMemo(() => {
    const detailKey =
      name === "aircon-service"
        ? `${name}-${packageDetailsFilter?.serviceTypes?.[0]}`
        : name;
    return safeGet(
      serviceDetails,
      detailKey,
      defaultServiceDetails,
    ) as IServiceDetail;
  }, [name]);

  const { startPrice } = pageServiceDetails;

  const pricingSection = useMemo(() => {
    return (
      <View>
        <Typography variant="body-md" color="foreground-intermediate">
          Starting from
        </Typography>
        <View className="flex flex-row items-center">
          <Typography
            variant="label-lg"
            color="brand-primary"
          >{`${formatPrice(startPrice, 0)}`}</Typography>
          <Typography variant="body-sm" color="foreground-intermediate">
            /{getServiceUnit(name)}
          </Typography>
        </View>
      </View>
    );
  }, [name, startPrice]);

  return (
    <View className="flex flex-row gap-2">
      {showPricingSection && pricingSection}
      <ActionNavigation buttonText="Book Service" onClickButton={onForward} />
      <NativeActionNavigation
        name={name}
        isReviewService={isReviewService}
        buttonText="Book Service"
        onClickButton={onForward}
        leftRender={pricingSection}
      />
    </View>
  );
};
